module.exports = __webpack_public_path__ + "static/media/searchBarCross.1b035b5b.svg";